
import { Component, Vue, Watch } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app'
import { delObjEmptyKey } from '@/utils'
import { Form as ElForm } from 'element-ui'
import { dateToSeconds, getOneDate, pickerOptions } from '@/utils/dateTime'
import { antRebateReportlist } from '@/api/report'

@Component({
  name: 'rebate',
  components: {}
})
export default class extends Vue {
  private queryForm: any = {
    ant_username: null,
    start_time: null,
    end_time: null
  }
  private date: any[] = getOneDate()
  private pickerOptions = pickerOptions

  private total = 0
  private list: any[] = []
  private listLoading: Boolean = false

  @Watch('date', { immediate: true })
  private onDateChang() {
    this.pickerChange()
  }

  // 创建时间监听
  private pickerChange() {
    if (this.date) {
      this.queryForm.start_time = dateToSeconds(this.date[0])
      this.queryForm.end_time = dateToSeconds(this.date[1])
    } else {
      this.queryForm.start_time = null
      this.queryForm.end_time = null
    }
  }

  private select() {
    this.currentPage = 1
    this.hadleGetFilesListApi()
  }

  private reset() {
    this.queryForm = {
      ant_username: null,
      start_time: null,
      end_time: null
    }
    this.currentPage = 1
    this.date = getOneDate()
    this.pickerChange()
    this.hadleGetFilesListApi()
  }

  // 分页器设置
  private pagesize: number = 20
  private handleSizeChange(size) {
    this.pagesize = size
    this.hadleGetFilesListApi()
  }

  // 分页切换
  private currentPage: number = 1
  private handleCurrentChange(currentPage) {
    this.currentPage = currentPage
    this.hadleGetFilesListApi()
  }

  // 对所有数据进行分页处理 发送请求
  private async hadleGetFilesListApi() {
    try {
      this.listLoading = true
      const data: any = {
        ...this.queryForm
        // page_size: this.pagesize,
        // page: this.currentPage
      }
      await antRebateReportlist(data).then((res: any) => {
        this.list = Object.values(res)
        this.listLoading = false
      })
    } catch (e) {
      this.listLoading = false
    }
  }

  private siteName = this.$store.state.app.enterprise.ssl_switch.site_name
  private systemName: any = 'Admin System'
  private sitelogo: any = this.$store.state.app.enterprise.ssl_switch.site_logo
  private systemLogo: any = ''

  private async init() {
    this.hadleGetFilesListApi()
    if (this.siteName && this.siteName !== '') {
      AppModule.SetSiteName(this.siteName)
      document.title = this.siteName + ' ' + this.$t(`route.operation`)
    } else {
      AppModule.SetSiteName(this.systemName)
      document.title = this.$t(`route.rebate`) + '- Admin System'
    }
    if (this.sitelogo && this.sitelogo !== '') {
      AppModule.SetSiteLogo(this.sitelogo)
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.sitelogo
      document.getElementsByTagName('head')[0].appendChild(link)
    } else {
      AppModule.SetSiteLogo(this.systemLogo)
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.systemLogo
      document.getElementsByTagName('head')[0].appendChild(link)
    }
  }

  mounted() {
    this.init()
  }
}
